import {memo, useContext, createContext} from 'react';
import {isEqual} from 'lodash';

const newContext = debugName => {
  const Context = createContext();
  Context.displayName = `${debugName}Context`;
  const _withContext = (Component, keys) => {
    const displayName = `${Component.displayName || Component.name}[${debugName}Provider]`;
    Component = memo(Component);
    const Wrapped = props => {
      let state = useContext(Context);
      if (import.meta.env.VITE_IS_LOCALHOST) {
        keys.forEach(key => {
          const keyName = typeof key === 'string' ? key : Object.keys(key)[0];
          if (keys.filter(_key => isEqual(_key, key)).length > 1) {
            console.error(`Dublicate context value, name '${key}'`); // eslint-disable-line no-console
          }
          if (Object.prototype.hasOwnProperty.call(props, keyName) && Object.prototype.hasOwnProperty.call(state, keyName)) {
            console.error(`Dublicate in props and context value, name '${key}'`); // eslint-disable-line no-console
          }
          if (state === undefined) { // eslint-disable-line no-undefined
            console.error(`You probably misspelled Context name inside ${debugName}Provider.js, or trying to import context in the same layer`); // eslint-disable-line no-console
          }
          if (!Object.prototype.hasOwnProperty.call(state, keyName)) {
            console.error(`There is no '${JSON.stringify(key)}' in the ${debugName}Provider.js (${displayName})`); // eslint-disable-line no-console
          }
        });
      }
      state = keys.reduce(
        (acc, key) => {
          const [keyName, varName] = typeof key === 'string' ? [key, key] : Object.entries(key)[0];
          acc[varName] = state[keyName];
          return acc;
        },
        {},
      );
      return (
        <Component
          {...state}
          {...props}
        />
      );
    };
    const Memoized = memo(Wrapped);
    Wrapped.displayName = displayName;
    Memoized.displayName = displayName;
    return Memoized;
  };

  const _useContext = keys => {
    let state = useContext(Context);
    if (import.meta.env.VITE_IS_LOCALHOST) {
      keys.forEach(key => {
        const keyName = typeof key === 'string' ? key : Object.keys(key)[0];
        if (keys.filter(_key => isEqual(_key, key)).length > 1) {
          console.error(`Dublicate context value, name '${key}'`); // eslint-disable-line no-console
        }
        if (!Object.prototype.hasOwnProperty.call(state, keyName)) {
          console.error(`There is no '${JSON.stringify(key)}' in the context`); // eslint-disable-line no-console
        }
      });
    }
    state = keys.reduce(
      (acc, key) => {
        const [keyName, varName] = typeof key === 'string' ? [key, key] : Object.entries(key)[0];
        acc[varName] = state[keyName];
        return acc;
      },
      {},
    );
    return state;
  };

  return {Provider: Context.Provider, withContext: _withContext, useContext: _useContext, Context};
};

const ProfileContext = newContext('Profile');
const FetchApiContext = newContext('FetchApi');
const ModalsContext = newContext('ModalsContext');

export {
  ModalsContext,
  ProfileContext,
  FetchApiContext,
};
